import React from 'react'

const InputLabel = ({className = "", label, required }) => (
    <div className={className} style={{ minWidth: "120px", fontSize: 16, margin: "5px 0px 5px 5px", fontWeight: "500" }}>
        {label}
        {required && <font color="red">*</font>}
    </div>
);

export default InputLabel;